<template>
  <v-container>
    <template v-if="data !== null">
      <v-row no-gutters v-for="(item, index) in data" :key="index">
        <v-col cols="12" sm="9" align="center">
          <v-row no-gutters>
            <template v-if="$vuetify.breakpoint.smAndDown === true">
              <v-col cols="12">
                <v-icon color="primary">mdi-numeric-{{ reversed == true ? data.length - index + offset : index + offset + 1 }}-circle-outline</v-icon>
              </v-col>
              <v-col cols="12">
                <ApexBarChart
                  :data="item.cellVoltages"
                  :dataLine="item.averageVoltages"
                  :dataOV="item.overVoltage"
                  :dataUV="item.underVoltage"
                  :dataHOV="item.higherOutOfRange"
                  :dataHUV="item.lowerOutOfRange"
                  :dataBalancing="item.balancingArray"
                  :label="item.cellIndexes"
                  type="Voltage"
                  :dark="$vuetify.theme.dark"
                />
              </v-col>
            </template>

            <template v-else>
              <v-col cols="1" align="center">
                <br /><br /><br />
                <v-icon color="primary">mdi-numeric-{{ reversed == true ? data.length - index + offset : index + offset + 1 }}-circle-outline</v-icon>
              </v-col>

              <v-col cols="11">
                <ApexBarChart
                  :data="item.cellVoltages"
                  :dataLine="item.averageVoltages"
                  :dataOV="item.overVoltage"
                  :dataUV="item.underVoltage"
                  :dataHOV="item.higherOutOfRange"
                  :dataHUV="item.lowerOutOfRange"
                  :dataBalancing="item.balancingArray"
                  :label="item.cellIndexes"
                  type="Voltage"
                  :dark="$vuetify.theme.dark"
                />
              </v-col>
            </template>
          </v-row>
        </v-col>

        <v-col cols="12" sm="3" align="center">
          <v-row no-gutters>
            <v-col cols="12" :style="getColorTemperature(item.tempMax, true)">
              <v-icon :color="getColorTemperature(item.tempMax, false)">mdi-thermometer-plus</v-icon>
              <v-icon :color="getColorTemperature(item.tempMax, false)">mdi-battery-medium</v-icon>:
              <b> {{ item.tempMax }} </b>
              <v-icon :color="getColorTemperature(item.tempMax, false)">mdi-temperature-celsius</v-icon>
            </v-col>
            <v-col cols="12" :style="getColorTemperature(item.tempMedian, true)">
              <v-icon :color="getColorTemperature(item.tempMedian, false)">mdi-thermometer-lines</v-icon>
              <v-icon :color="getColorTemperature(item.tempMedian, false)">mdi-battery-medium</v-icon> : <b>{{ item.tempMedian }} </b>
              <v-icon :color="getColorTemperature(item.tempMedian, false)">mdi-temperature-celsius</v-icon>
            </v-col>
            <v-col cols="12" :style="getColorTemperature(item.tempIcInternal, true)">
              <v-icon :color="getColorTemperature(item.tempIcInternal, false)">mdi-thermometer</v-icon>
              <v-icon :color="getColorTemperature(item.tempIcInternal, false)">mdi-chip</v-icon> : <b> {{ item.tempIcInternal }} </b>
              <v-icon :color="getColorTemperature(item.tempIcInternal, false)">mdi-temperature-celsius</v-icon>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import ApexBarChart from "../../charts/apexcharts/ApexBarChart.vue";
import { getColorTemperature } from "../../../colors.js";

export default {
  name: "BatteryDigitalPacks",
  components: {
    ApexBarChart,
  },
  props: {
    data: {
      type: Array,
      require: false,
    },
    offset: {
      type: Number,
      require: false,
    },
    reversed: {
      type: Boolean,
      require: false,
    },
  },
  methods: {
    getColorTemperature,
  },
};
</script>

<style scoped></style>
